import get from 'transmute/get';
export const getCurrentThreadId = get('currentThreadId');